import { Client } from "./Client";

export class PlumeService {
  constructor(private client: Client) {}

  async fetchPlume(
    facilitiesID: string,
    sources: { sources: any },
    startDate?: string,
    endDate?: string,
    avertime?: number | string,
    hours?: number,
    mode?: string,
    pflFileId?: string,
    sfcFileId?: string,
    groupIds?: string[]
  ) {
    return await this.client.fetchPlume(
      facilitiesID,
      sources,
      startDate,
      endDate,
      avertime,
      hours,
      mode,
      pflFileId,
      sfcFileId,
      groupIds
    );
  }

  async getPlumeDocs(plumeID: string) {
    return await this.client.getPlumeDocs(plumeID);
  }

  async fetchAutoOccurrencesCount(plumeID: string): Promise<number> {
    return await this.client.fetchAutoOccurrencesCount(plumeID);
  }

  /** Pluma persistida (sem reprocessar) — gate: operador da facility. */
  async fetchSavedPlume(plumeID: string) {
    return await this.client.fetchPlumeForOccurrence(plumeID);
  }
}
